<ng-container *ngIf="active || forceRender">
  <ng-template [ngTemplateOutlet]="content"></ng-template>
</ng-container>